import React from 'react';
import { Grid, GridProps } from '@mui/material';

export const DpGridTendence: React.FC<React.PropsWithChildren<GridProps>> = ({ children }) => (
	<Grid container spacing="20px">
		{children}
	</Grid>
);
